import { Card, Button, Typography } from 'antd';
import { FileTextOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {FC} from "react";

const { Text } = Typography;

const StyledCard = styled(Card)`
  margin-bottom: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
  
  .ant-card-body {
    padding: 12px 16px;
  }
`;

const JobInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const JobDetails = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const JobTitle = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  color: #333;
`;

interface JobContextCardProps {
  jobId: string;
  jobTitle: string;
}

export const JobContextCard: FC<JobContextCardProps> = ({ jobId, jobTitle }) => {
  const navigate = useNavigate();

  const handleViewJob = () => {
    navigate(`/jobs/${jobId}`);
  };

  return (
    <StyledCard size="small">
      <JobInfoContainer>
        <JobDetails>
          <FileTextOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Anschreiben für:
            </Text>
            <br />
            <JobTitle ellipsis={{ tooltip: jobTitle }}>
              {jobTitle}
            </JobTitle>
          </div>
        </JobDetails>
        <Button
          type="primary"
          ghost
          size="small"
          icon={<EyeOutlined />}
          onClick={handleViewJob}
        >
          Details ansehen
        </Button>
      </JobInfoContainer>
    </StyledCard>
  );
};
